$('dialog').each(function () {
    let $this = $(this);
    $this[0].addEventListener('click', function (e) {
        let rect = this.getBoundingClientRect();
        let isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height
            && rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
        if (!isInDialog) {
            this.close();
        }
    });

    $this[0].addEventListener('close', function () {
        $(this).find('iframe').attr('src', '');
    });

    $this.find('.close').click(function (e) {
        e.preventDefault();
        $this[0].close();
    });

    if (typeof HTMLDialogElement === 'function') {
        console.log('Supports Dialog');
    } else {
        console.log('Moving Dialog');
        $this.appendTo(document.body).css('position', 'fixed').css('top', '4vh');
    }
});
